import { FlightType } from "types/flights/search";
import { dateIsBeforeOrEqual } from "../date-ops";
const successValidation = {
  success: true,
  message: "success",
  field: "",
  index: 0
};
export const validateFlightInfo = (info, flightType, passengersDetails) => {
  if (!info || info.length === 0) {
    return {
      success: false,
      message: "SEARCH_VALIDATIONS.NO_FLIGHT_INFO",
      field: "origin",
      index: 0
    };
  }
  let validation = successValidation;
  const passengersValidation = validatePassengersDetails(passengersDetails);
  if (!passengersValidation.validation.success) {
    return passengersValidation.validation;
  }
  switch (flightType) {
    case FlightType.ONE_WAY:
      validation = isValidOneWayTrip(info[0], 0);
      break;
    case FlightType.ROUND_TRIP:
      validation = isValidRoundTrip(info[0], 0);
      break;
    case FlightType.MULTI_DESTINATION:
      validation = isValidMultidestinationTrip(info);
      break;
  }
  return validation;
};
export const validatePassengersDetails = passengersDetails => {
  let validation = successValidation;
  const totalPassengers = passengersDetails.adults + passengersDetails.children + passengersDetails.infants + passengersDetails.infants_with_seat;
  const totalInfants = passengersDetails.infants + passengersDetails.infants_with_seat;
  const adults = passengersDetails.adults;
  const validations = {
    totalPassengerQtyValid: totalPassengers <= 9,
    enoughAdultsForInfants: totalInfants <= passengersDetails.adults,
    enoughAdultsForChildren: passengersDetails.children <= passengersDetails.adults * 2,
    enoughTotalAdults: totalInfants + passengersDetails.children <= passengersDetails.adults * 2,
    atLeastOneAdult: adults > 0
  };
  const messagesByValidation = {
    totalPassengerQtyValid: "SEARCH_VALIDATIONS.INVALID_TOTAL_PASSENGER_QTY",
    enoughAdultsForInfants: "SEARCH_VALIDATIONS.NOT_ENOUGH_ADULTS_FOR_INFANTS",
    enoughAdultsForChildren: "SEARCH_VALIDATIONS.NOT_ENOUGH_ADULTS_FOR_CHILDREN",
    enoughTotalAdults: "SEARCH_VALIDATIONS.NOT_ENOUGH_TOTAL_ADULTS",
    atLeastOneAdult: "SEARCH_VALIDATIONS.AT_LEAST_ONE_ADULT_REQUIRED"
  };
  for (const failedValidation in validations) {
    if (!validations[failedValidation]) {
      validation = {
        success: false,
        message: messagesByValidation[failedValidation],
        field: "passengers_details",
        index: 0
      };
      break;
    }
  }
  return {
    validation,
    validationValues: validations
  };
};
export const isValidOneWayTrip = (flightInfo, index) => {
  if (!flightInfo) {
    return {
      success: false,
      message: "SEARCH_VALIDATIONS.NO_FLIGHT_INFO",
      field: "origin",
      index: 0
    };
  }
  let validation = successValidation;
  validation = originPresent(flightInfo, index);
  if (!validation.success) {
    return validation;
  }
  validation = destinationPresent(flightInfo, index);
  if (!validation.success) {
    return validation;
  }
  validation = originAndDestinationAreDifferent(flightInfo, index);
  if (!validation.success) {
    return validation;
  }
  validation = departureDatePresent(flightInfo, index);
  return validation;
};
export const isValidRoundTrip = (flightInfo, index) => {
  if (!flightInfo) {
    return {
      success: false,
      message: "SEARCH_VALIDATIONS.NO_FLIGHT_INFO",
      field: "origin",
      index: 0
    };
  }
  let validation = successValidation;
  validation = originPresent(flightInfo, index);
  if (!validation.success) {
    return validation;
  }
  validation = destinationPresent(flightInfo, index);
  if (!validation.success) {
    return validation;
  }
  validation = originAndDestinationAreDifferent(flightInfo, index);
  if (!validation.success) {
    return validation;
  }
  validation = dateRangePresent(flightInfo, index);
  return validation;
};
export const isValidMultidestinationTrip = destinationsFlightInfo => {
  let validation = successValidation;
  for (let flightInfoIndex = 0; flightInfoIndex < destinationsFlightInfo.length; flightInfoIndex++) {
    validation = isValidOneWayTrip(destinationsFlightInfo[flightInfoIndex], flightInfoIndex);
    if (!validation.success) {
      return validation;
    }
  }
  validation = multidestinationDatesAreValid(destinationsFlightInfo);
  return validation;
};
const originPresent = (flightInfo, index) => {
  return flightInfo.origin ? successValidation : {
    success: false,
    message: "SEARCH_VALIDATIONS.NO_ORIGIN_SELECTED",
    field: "origin",
    index
  };
};
const destinationPresent = (flightInfo, index) => {
  return flightInfo.destination ? successValidation : {
    success: false,
    message: "SEARCH_VALIDATIONS.NO_DESTINATION_SELECTED",
    field: "destination",
    index
  };
};
const dateRangePresent = (flightInfo, index) => {
  return flightInfo.departure_date && flightInfo.return_date ? successValidation : {
    success: false,
    message: "SEARCH_VALIDATIONS.NO_DATE_RANGE_SELECTED",
    field: "departure_date",
    index
  };
};
const departureDatePresent = (flightInfo, index) => {
  return flightInfo.departure_date ? successValidation : {
    success: false,
    message: "SEARCH_VALIDATIONS.NO_DEPARTURE_DATE_SELECTED",
    field: "departure_date",
    index
  };
};
const originAndDestinationAreDifferent = (flightInfo, index) => {
  return flightInfo.origin !== flightInfo.destination ? successValidation : {
    success: false,
    message: "SEARCH_VALIDATIONS.ORIGIN_AND_DESTINATION_MUST_BE_DIFFERENT",
    field: "destination",
    index
  };
};
const multidestinationDatesAreValid = flightInfos => {
  // Checks the departure date in each flight, every departure date must be higher than the last departure date
  for (let flightInfoIndex = 1; flightInfoIndex < flightInfos.length; flightInfoIndex++) {
    const currentDepartureDate = flightInfos[flightInfoIndex].departure_date;
    const lastDepartureDate = flightInfos[flightInfoIndex - 1].departure_date;
    if (currentDepartureDate && lastDepartureDate && !dateIsBeforeOrEqual(lastDepartureDate, currentDepartureDate)) {
      return {
        success: false,
        message: "SEARCH_VALIDATIONS.MULTIDESTINATION_INVALID_DEPARTURE_DATES",
        field: "departure_date",
        index: flightInfoIndex
      };
    }
  }
  return successValidation;
};